<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Listado de visitas</h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button type="button" @click="consultar" class="btn-info">
            <i class="fa fa-search"></i><span>Consultar</span>
          </button>
          <button
            type="button"
            @click="mostrarHistoricos"
            class="btn-secondary"
          >
            <i class="fa fa-history"></i><span>Historial</span>
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-md-4">
        <div class="form-field select">
          <div class="select-field">
            <select name="estado" v-model="form.estado" id="estado">
              <option value="T">Todas</option>
              <option value="P">Pendientes</option>
              <option value="I">Iniciadas</option>
              <option value="F">Finalizadas</option>
              <option value="C">Canceladas</option>
              <option value="A">Anuladas</option>
            </select>
            <label for="estado">Estado</label>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-4">
        <div class="form-field select2">
          <div class="select2-field">
            <v-select
              placeholder="Seleccione..."
              @search="onSearchRuta"
              @input="inputRuta"
              id="ruta_id"
              :options="rutas"
              label="descripcion"
              v-model="selectedRuta"
            ></v-select>
            <label for="ruta_id">Ruta</label>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-4">
        <div class="form-field select2">
          <div class="select2-field">
            <v-select
              placeholder="Seleccione..."
              @search="onSearchSupervisores"
              @input="inputSupervisor"
              id="supervisor_id"
              :options="supervisores"
              label="nombre"
              v-model="selectedSupervisor"
            ></v-select>
            <label for="supervisor_id">Supervisor</label>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-4">
        <div class="form-field select2">
          <div class="select2-field">
            <v-select
              placeholder="Seleccione..."
              @search="onSearchVerificadores"
              @input="inputVerificador"
              id="verificador_id"
              :options="verificadores"
              label="descripcion"
              v-model="selectedVerificador"
            ></v-select>
            <label for="verificador_id">Verificador</label>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-4">
        <div class="form-field select2">
          <div class="select2-field">
            <v-select
              placeholder="Seleccione..."
              @search="onSearchRecaudadores"
              @input="inputRecaudador"
              id="recaudador_id"
              :options="recaudadores"
              label="nombre"
              v-model="selectedRecaudador"
            ></v-select>
            <label for="recaudador_id">Recaudador</label>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-4">
        <div class="form-field select">
          <div class="select-field">
            <select name="tipo_fecha" id="tipo_fecha" v-model="form.tipo_fecha">
              <option value="H">Hoy</option>
              <option value="A">Ayer</option>
              <option value="P">Personalizada</option>
            </select>
            <label for="tipo_fecha">Tipo de fecha</label>
          </div>
        </div>
      </div>
      <div v-show="form.tipo_fecha === 'P'" class="col-xs-12 col-md-4">
        <div class="form-field">
          <div class="datepicker-field">
            <VueCtkDateTimePicker
              id="desde"
              v-model="form.desde"
              locale="es"
              only-date
              no-label
              button-now-translation="Ahora"
              format="YYYY-MM-DD"
              formatted="YYYY-MM-DD"
              label="Seleccione fecha..."
            />
            <label>Desde</label>
          </div>
        </div>
      </div>
      <div v-show="form.tipo_fecha === 'P'" class="col-xs-12 col-md-4">
        <div class="form-field">
          <div class="datepicker-field">
            <VueCtkDateTimePicker
              id="hasta"
              v-model="form.hasta"
              locale="es"
              only-date
              no-label
              button-now-translation="Ahora"
              format="YYYY-MM-DD"
              formatted="YYYY-MM-DD"
              label="Seleccione fecha..."
            />
            <label>Hasta</label>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-4">
        <div class="form-field select">
          <div class="select-field">
            <select id="dia_cobro" v-model="form.dia_cobro">
              <option value="">Todos</option>
              <option value="1">Lunes</option>
              <option value="2">Martes</option>
              <option value="3">Miércoles</option>
              <option value="4">Jueves</option>
              <option value="5">Viernes</option>
              <option value="6">Sábado</option>
              <option value="7">Domingo</option>
            </select>
            <label for="dia_cobro">Día de cobro</label>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-4">
        <div class="form-field select">
          <div class="select-field">
            <select name="bodega" v-model="form.bodega_id" id="bodega">
              <option value="">Todas</option>
              <option
                :value="bodega.id"
                v-for="bodega in bodegas"
                :key="bodega.id"
              >
                {{ bodega.descripcion }}
              </option>
            </select>
            <label for="bodega">Sucursal</label>
          </div>
        </div>
      </div>
    </div>
    <k-table
      :params="form"
      estadoCancelado="A"
      estadoAutorizado="F"
      :buscarButton="false"
      :filterStatus="false"
      @seleccionar="seleccionarVisita"
      @exportarVisitas="exportarVisitas"
      :path="path"
      :createButton="false"
      :editButton="false"
      :deleteButton="false"
      ref="listaVisitas"
      :buttons="[
        {
          event: 'exportarVisitas',
          icon: 'fa-file-excel-o',
          class: 'btn-success btn--text',
        },
      ]"
      :columns="[
        {
          display: 'Sucursal',
          value: 'ruta.bodega.descripcion',
        },
        {
          display: 'Fecha',
          value: 'fecha',
        },
        {
          display: 'Ruta',
          value: 'descripcion_ruta',
        },
        {
          display: 'Supervisor',
          value: 'nombre_supervisor',
        },
        {
          display: 'Verificador',
          value: 'descripcion_verificador',
        },
        {
          display: 'Recaudador',
          value: 'nombre_recaudador',
        },
        {
          display: 'Día de cobro',
          value: 'descripcion_dia_cobro',
        },
        {
          display: 'Creador',
          value: 'creador.nombre',
        },
        {
          display: 'Creación',
          value: 'created_at',
        },
        {
          display: 'Modificador',
          value: 'modificador.nombre',
        },
        {
          display: 'Modificación',
          value: 'updated_at',
        },
        {
          display: 'Observación',
          value: 'observacion',
        },
        {
          display: 'Estado',
          value: 'descripcion_estado',
        },
      ]"
    ></k-table>
    <div class="modal-buttons">
      <button type="button" @click="cerrar" class="btn-danger btn--text">
        <i class="fa fa-times"></i><span>Cerrar</span>
      </button>
    </div>
    <modal
      name="historicos"
      height="auto"
      width="70%"
      scrollable
      adaptive
      resizable
      reset
    >
      <reportes-historicos-excel tipoReporte="vta"></reportes-historicos-excel>
    </modal>
  </div>
</template>

<script>
export default {
  props: {
    bodegas: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
  },
  data: function () {
    return {
      path: url + "/logistica/visitas",
      form: {
        tipo_fecha: "H",
        desde: moment(new Date()).format("YYYY-MM-DD"),
        hasta: moment(new Date()).format("YYYY-MM-DD"),
        estado: "T",
        supervisor_id: "",
        recaudador_id: "",
        verificador_id: "",
        ruta_id: "",
        dia_cobro: "",
        bodega_id: "",
        idBodega: "",
      },
      selectedSupervisor: null,
      supervisores: [],
      selectedVerificador: null,
      verificadores: [],
      selectedRecaudador: null,
      recaudadores: [],
      selectedRuta: null,
      rutas: [],
    };
  },
  methods: {
    serialize: function (obj) {
      return (
        "?" +
        Object.keys(obj)
          .reduce(function (a, k) {
            let val = obj[k];
            let esArray = false;
            if (val instanceof Date) {
              val = val.toLocaleDateString("en");
            } else if (val instanceof Array) {
              esArray = true;
              let acumulador = "";
              for (let i = 0; i < val.length; i++) {
                acumulador += k + "%5B%5D=" + val[i];
                if (i != val.length - 1) {
                  acumulador += "&";
                }
              }
              val = acumulador;
              a.push(val);
            }
            if (!esArray) a.push(k + "=" + encodeURIComponent(val));
            return a;
          }, [])
          .join("&")
      );
    },
    exportarVisitas: function (row) {
      const { id: visita_id } = row;
      this.form.idBodega = this.form.bodega_id;
      let queryString = this.serialize(this.form) + "&tipo_consulta=V&visita_id=" + visita_id;
      window.open(url + "/logistica/pedidos" + queryString, "_blank");
    },
    consultar: function () {
      this.$refs.listaVisitas.loadRows();
    },
    onSearchVerificadores: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.verificadores = json;
          loading(false);
        } else loading(false);
      };
      xmlhttp.open(
        "GET",
        url + "/search/verificadores?tipo=V&search=" + search,
        true
      );
      xmlhttp.send();
    },
    onSearchRecaudadores: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.recaudadores = json;
          loading(false);
        } else loading(false);
      };
      xmlhttp.open(
        "GET",
        url + "/search/usuarios?tipo=R&search=" + search,
        true
      );
      xmlhttp.send();
    },
    onSearchSupervisores: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.supervisores = json;
          loading(false);
        } else loading(false);
      };
      xmlhttp.open(
        "GET",
        url + "/search/usuarios?tipo=S&search=" + search,
        true
      );
      xmlhttp.send();
    },
    onSearchRuta: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.rutas = json;
          loading(false);
        } else loading(false);
      };
      xmlhttp.open("GET", url + "/search/rutas?search=" + search, true);
      xmlhttp.send();
    },
    inputRuta: function () {
      if (this.selectedRuta != null) this.form.ruta_id = this.selectedRuta.id;
      else this.form.ruta_id = "";
    },
    inputSupervisor: function () {
      if (this.selectedSupervisor != null)
        this.form.supervisor_id = this.selectedSupervisor.id;
      else this.form.supervisor_id = "";
    },
    inputVerificador: function () {
      if (this.selectedVerificador != null)
        this.form.verificador_id = this.selectedVerificador.id;
      else this.form.verificador_id = "";
    },
    inputRecaudador: function () {
      if (this.selectedRecaudador != null)
        this.form.recaudador_id = this.selectedRecaudador.id;
      else this.form.recaudador_id = "";
    },
    cerrar: function () {
      this.$emit("cerrar");
    },
    seleccionarVisita: function (visita) {
      this.$emit("seleccionar", visita);
    },
    mostrarHistoricos: function () {
      this.$modal.show("historicos");
    },
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/visitas/ListaVisitas.vue